import Vue from 'vue'
import App from './App.vue'
import router from './router'

import { BootstrapVue, ModalPlugin } from "bootstrap-vue";
import Scrollspy from 'vue2-scrollspy';
import VueYoutube from 'vue-youtube'
import axios from "axios";
import VueAxios from "vue-axios";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

var VueScrollTo = require('vue-scrollto');

import VueParticles from 'vue-particles'
import VModal from "vue-js-modal";

Vue.config.productionTip = false

Vue.use(VueYoutube)
Vue.use(VueParticles)

// Install BootstrapVue
Vue.use(BootstrapVue)
// Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

Vue.use(VueScrollTo)
Vue.use(Scrollspy);

Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VModal);

Vue.use(Toast, {});

import "@/assets/scss/style.scss";


new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
